import React, {useContext, useEffect, useState} from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { TextInput } from 'Ficha/components/TextInput'
import FeesTable from 'Ficha/components/fees/FeesTable'
import NewTable from 'Ficha/components/fees/NewTable'
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { useForm, Controller } from "react-hook-form";
import { UserContext } from 'context/userContext'
import db from 'firebase/dbConfig'
import { apagarTabela } from 'firebase/firestoreData'

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  },
  field:{
    margin: '10px auto',
  },
  tableBox:{
    padding: 10,
    paddingTop: 20,
  },
  formControl:{
    margin: 20,
  },
  miniTable:{
    maxWidth: 360,
    margin: '0 auto'
  },
  miniTableRow:{
    height: 42,
  },
  deleteButton:{
    margin: 20,
    border: '1px solid blue',
    color: 'blue'
  },
  heading:{
    marginLeft: 10,
  }
};

const useStyles = makeStyles(styles);

export default function Fees(props) {
  const classes = useStyles();
  const [tabelas, setTabelas] = useState([])
  const [tabelaUsada, setTabelaUsada] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const {currentUser} = useContext(UserContext)
  const {control} = useForm();
  const ficha  = props.location.state

  useEffect(() => {
    if (currentUser){
      db.collection('users').doc(currentUser.uid).collection('tabelasCadastradas').onSnapshot(snapshot => {
        const allRecords = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setTabelas(allRecords)
      });
    }
  }, [currentUser]);

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={8}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>
                Previsão Orçamentária para Procedimento Anestésico
              </h4>
              <p className={classes.cardCategoryWhite}>
                Para alterar as informações preenchidas automaticamente,
                voltar para ficha de A.P.A.
              </p>
              <p className={classes.cardCategoryWhite}>
                Caso queira discriminar porte e valor de mais de um procedimento,
                é necessário deixar apenas um por linha na ficha de A.P.A.
              </p>
            </CardHeader>
            <CardBody>
            <form>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TextInput
                    className={classes.field}
                    label="Nome Completo"
                    name="nomeCompleto"
                    value={ficha.nome}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <TextInput
                    className={classes.field}
                    label="Anestesiologista"
                    name="user"
                    value={currentUser.displayName}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TextInput
                    className={classes.field}
                    label="Cirurgião"
                    name="cirurgiao"
                    value={ficha.cirurgiao}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <TextInput
                    className={classes.field}
                    label="Hospital"
                    name="hospital"
                    value={ficha.hospital}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TextInput
                    className={classes.field}
                    label="Convênio"
                    name="convenio"
                    value={ficha.convenio}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <TextInput
                    className={classes.field}
                    label="Acomodação"
                    name="acomodacao"
                    value={ficha.acomodacao}
                  />
                </GridItem>
              </GridContainer>
              </form>

              <FeesTable tabela={tabelaUsada}
                         ficha={ficha}
               />
            </CardBody>
          </Card>
          <Accordion className={classes.help}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
            >
              <HelpOutlineIcon/>
              <Typography className={classes.heading}>
                <b> Precisa de ajuda para fazer o Orçamento</b>?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
              - Existem basicamente <b>duas formas</b> de fazer o orçamento:<br/>
                1) A forma <b>mais simples</b> é apenas colocar os valores ao lado
                de cada procedimento e clicar em salvar. Para essa método, preencher
                portes e vias de cada procedimento é opcional. Importante lembrar
                que, para discriminar mais de um procedimento, é necessário deixar
                apenas um por linha na ficha de A.P.A.<br/>
                2) A segunda forma é um pouco mais elaborada, porém <b>recomendada</b> para
                quem pretende utilizar a ferramenta de Orçamento com alguma frequência.
                Cadastre uma tabela (ou mais de uma) com os valores que deseja usar, essa
                tabela ficará salva para uso futuro. Selecione a tabela desejada.
                Em seguida, basta preencher portes e vias de cada procedimento.
                Opcionalmente, é possivel selecionar a opção para dobrar os
                valores ou adicionar 30%.<br/>
                Depois de salvos, os orçamentos estão disponíveis para impressão
                em <b>PDF ORÇAMENTO</b>, localizado no mesmo menu da opção <b>ORÇAR</b>.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </GridItem>

        <GridItem xs={12} sm={12} md={4}>

          <Card profile className={classes.tableBox}>
              <Typography gutterBottom> ESCOLHA A TABELA A SER APLICADA:</Typography>
              <Typography variant="caption">Caso você não tenha cadastrado
                nenhuma tabela, faça isso no próximo bloco</Typography>
                <FormControl className={classes.formControl}>
                  <Controller name="tabelaAplicada" defaultValue="" control={control}
                              render={({ onChange, onBlur, value, name, ref }) => (
                    <Select defaultValue="" onChange={(e) => {setTabelaUsada(e.target.value); setConfirmDelete(false)}}>
                      {tabelas.map((tabela, index) => (
                        <MenuItem key={index+tabela.id} value={tabela}>{tabela.id}</MenuItem>
                       ))}
                    </Select>
                    )}
                  />
               </FormControl>
            {tabelaUsada &&
            <>
             <Table className={classes.miniTable} size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>PORTE ANESTÉSICO</TableCell>
                    <TableCell align="right">Valor</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell component="th" scope="row">Porte 0</TableCell>
                    <TableCell align="right">{tabelaUsada['0']}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">Porte 1</TableCell>
                    <TableCell align="right">{tabelaUsada['1']}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">Porte 2</TableCell>
                    <TableCell align="right">{tabelaUsada['2']}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">Porte 3</TableCell>
                    <TableCell align="right">{tabelaUsada['3']}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">Porte 4</TableCell>
                    <TableCell align="right">{tabelaUsada['4']}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">Porte 5</TableCell>
                    <TableCell align="right">{tabelaUsada['5']}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">Porte 6</TableCell>
                    <TableCell align="right">{tabelaUsada['6']}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">Porte 7</TableCell>
                    <TableCell align="right">{tabelaUsada['7']}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">Porte 8</TableCell>
                    <TableCell align="right">{tabelaUsada['8']}</TableCell>
                  </TableRow>
               </TableBody>
            </Table>
            {confirmDelete ?
              <Button variant="outlined" className={classes.deleteButton} onClick={()=>{apagarTabela(currentUser.uid, tabelaUsada['nomeTabela']); setConfirmDelete(false)}}>
                CONFIRMA EXCLUSÃO {tabelaUsada['nomeTabela']}?
              </Button>
              :
              <Button variant="outlined" className={classes.deleteButton} onClick={()=>{setConfirmDelete(true)}}>
                APAGAR {tabelaUsada['nomeTabela']}
              </Button>
            }
          </>
          }
          </Card>
          <NewTable/>
        </GridItem>
      </GridContainer>
    </div>
  );
}
